import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const restoreBookingApi = createApi({
  reducerPath: 'restoreBookingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_EVENT}/bookings-core/api/v1/bookings/storage`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['restore'],
  endpoints: (builder) => ({
    saveBooking: builder.mutation({
      query: (body) => ({
        url: 'save',
        method: 'POST',
        body: body,
      }),
    }),
    getStore: builder.query({
      query: (order) => `${order}`,
      providesTags: ['restore'],
    }),
  }),
});

export const { useSaveBookingMutation, useGetStoreQuery } = restoreBookingApi;

export const { getStore } = restoreBookingApi.endpoints;
